const initialState = {
    title: '',
    fname: '',
    lname: '',
    address: '',
    logo: false,
};
const profile = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INPUT_PAGE_PROFILE':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default profile;
